import qs from 'qs';
import client, { url } from './client';

// 키오스크 정보 조회
export const loadKioskInfo = ({ clubID }) => {
  return client.get(`${url}/api/kiosk/info/${clubID}`);
};

// 키오스크 출석체크
export const kioskAttendCheck = ({ clubID, phoneLast4 }) => {
  return client.post(`${url}/api/kiosk/attend/${clubID}`, { phoneLast4 });
};

// 키오스크 출석체크 (회원 선택)
export const kioskAttendSelect = ({ clubID, playerID }) => {
  return client.post(`${url}/api/kiosk/attend/select/${clubID}`, { playerID });
};

// 키오스크용 클럽 정보 조회 (clubID로)
export const loadClubInfoByID = ({ clubID }) => {
  return client.get(`${url}/api/kiosk/club/info/${clubID}`);
};

// 직원 호출
export const kioskStaffCall = ({ clubID }) => {
  return client.post(`${url}/api/kiosk/staff/call/${clubID}`);
};

// 키오스크 정보 수정
export const modifyKioskInfo = ({ clubID, title, titleSize, memo, memoSize, imageURL, phone, password }) => {
  return client.post(`${url}/api/kiosk/info/${clubID}`, {
    title,
    titleSize,
    memo,
    memoSize,
    imageURL,
    phone,
    password,
  });
};

